'use client'

import { motion } from 'motion/react'
import ChevronDown from 'public/assets/chevron-down-primary.svg'
import { useState } from 'react'
import styles from './WhatWeDo.module.scss'

const services = [
  {
    title: 'Custom Software Development',
    description: 'Full-stack web, mobile, and cloud apps built from scratch or optimized for scale',
  },
  {
    title: 'Discovery Research',
    description: 'Intuitive interfaces rooted in user needs, with wireframes, prototypes, and visual identities',
  },
  {
    title: 'Product Design',
    description:
      'Holistic solutions for intuitive applications, emphasizing high quality and user focused product development from ideation to polished outcomes',
  },
  {
    title: 'System Modernisation & Integration',
    description: 'Overhauling legacy systems to cloud-first architectures, including microservices and event-driven designs',
  },
  {
    title: 'AI & Emerging Tech Solutions',
    description: 'Tailored LLM/RAG applications, data pipelines, and autonomous agents for intelligent automation',
  },
  {
    title: 'Security & Compliance Engineering',
    description:
      'Audit trails, data integrity, encryption, and SSO/identity federation designed in from day one — building to frameworks like GDPR and eIDAS, and integrating with established enterprise identity and document-management systems',
  },
  {
    title: 'QA & Testing',
    description: 'Manual and automated checks for flawless performance, including regression testing',
  },
]

const WhatWeDo = () => {
  const [expandedIndices, setExpandedIndices] = useState<Set<number>>(new Set())

  const toggleCard = (index: number) => {
    setExpandedIndices((prev) => {
      const newSet = new Set(prev)
      if (newSet.has(index)) {
        newSet.delete(index)
      } else {
        newSet.add(index)
      }

      return newSet
    })
  }

  return (
    <section className={styles['what-we-do']}>
      <div className={styles.title}>
        <h2>What We Do</h2>
        <p className={styles.subtitle}>End-to-End Software Excellence</p>
      </div>

      <div className={styles.services}>
        {services.map((service, index) => (
          <div key={index} className={styles.card}>
            <button className={styles.cardHeader} onClick={() => toggleCard(index)} aria-expanded={expandedIndices.has(index)}>
              <h3>{service.title}</h3>
              <motion.div
                className={styles.chevron}
                animate={{ rotate: expandedIndices.has(index) ? 180 : 0 }}
                transition={{ duration: 0.2, ease: [0.4, 0, 0.2, 1] }}
              >
                <ChevronDown />
              </motion.div>
            </button>

            <motion.div
              className={styles.cardContent}
              initial={false}
              animate={{
                opacity: expandedIndices.has(index) ? 1 : 0,
                maxHeight: expandedIndices.has(index) ? 300 : 0,
              }}
              transition={{ duration: 0.2 }}
            >
              <p>{service.description}</p>
            </motion.div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default WhatWeDo
